import React, { useState } from "react";
import Publications from "./publications";

const MAX_ITEMS = 2;

const YearsGroup = ({ years }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  function getRenderedItems(items) {
    /***
     * Cut items on state
     */
    if (isOpen) {
      return items;
    }
    return items.slice(0, MAX_ITEMS);
  }

  return (
    <>
      {getRenderedItems(
        Object.keys(years)
          .sort((a, b) => a.date - b.date)
          .reverse(),
      ).map((item) => {
        let first_year = years[item]["publications"][0]["year"];
        let publication = years[item];
        return (
          <dl className="years item" key={publication["publications"][0]["id"]}>
            <dt>{first_year}</dt>
            <Publications
              type_short={publication}
              key={publication["publications"][0]["id"]}
              publication={publication["publications"]}
            />
          </dl>
        );
      })}
      {Object.keys(years).length > MAX_ITEMS && (
        <a className="show_more" onClick={toggle}>
          {isOpen ? "...weniger anzeigen" : "...alle anzeigen"}
        </a>
      )}
    </>
  );
};

export default YearsGroup;
